<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >{{ $t('table.add') }}</el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column label="等级ID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.gradeId }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('grade.gradeName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.gradeName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('grade.petrolSaleAmt')" min-width="110px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.petrolSaleAmt }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column :label="$t('grade.petrolPoint')" min-width="110px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.petrolPoint }}</span>
        </template>
      </el-table-column>-->
      <el-table-column :label="$t('grade.dieselSaleAmt')" min-width="110px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.dieselSaleAmt }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column :label="$t('grade.dieselPoint')" min-width="110px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.dieselPoint }}</span>
        </template>
      </el-table-column>-->
      <el-table-column :label="$t('grade.status')" min-width="70px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('grade.updatedTime')" min-width="170px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedTime }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.actions')" align="center" width="250px">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleUpdate(scope.row)"
          >{{ $t('table.edit') }}</el-button>
          <el-button
            v-if="emp.isAdmin === 1 && scope.row.status === 0"
            type="success"
            size="mini"
            @click="handleModifyStatus(scope.row, 1)"
          >启用</el-button>
          <el-button
            v-if="emp.isAdmin === 1 && scope.row.status === 1"
            type="danger"
            size="mini"
            @click="handleModifyStatus(scope.row, 0)"
          >禁用</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="right"
        label-width="120px"
        style="margin:0px 30px;"
      >
        <el-form-item v-if="temp.gradeId" :label="$t('grade.gradeName')" prop="gradeName">
          <el-input v-model="temp.gradeName" :disabled="true" />
        </el-form-item>
        <el-form-item v-else :label="$t('grade.gradeName')" prop="gradeName">
          <el-input v-model.number="temp.gradeName" />
        </el-form-item>
        <el-form-item :label="$t('grade.petrolSaleAmt')" prop="petrolSaleAmt">
          <el-input v-model.number="temp.petrolSaleAmt" type="number" placeholder="0.00" />
        </el-form-item>
        <!--        <el-form-item :label="$t('grade.petrolPoint')" prop="petrolPoint">
          <el-input v-model.number="temp.petrolPoint" placeholder="0.00"/>
        </el-form-item>-->
        <el-form-item :label="$t('grade.dieselSaleAmt')" prop="dieselSaleAmt">
          <el-input v-model.number="temp.dieselSaleAmt" type="number" placeholder="0.00" />
        </el-form-item>
        <!--        <el-form-item :label="$t('grade.dieselPoint')" prop="dieselPoint">
          <el-input v-model.number="temp.dieselPoint" placeholder="0.00"/>
        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button
          v-if="dialogStatus=='create'"
          type="primary"
          @click="createData"
        >{{ $t('table.confirm') }}</el-button>
        <el-button v-else type="primary" @click="updateData">{{ $t('table.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogPvVisible" title="Reading statistics">
      <el-table :data="pvData" border fit highlight-current-row style="width: 100%">
        <el-table-column prop="key" label="Channel" />
        <el-table-column prop="pv" label="Pv" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogPvVisible = false">{{ $t('table.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { gradeList, createGrade, updateGrade } from '@/api/grade';
import waves from '@/directive/waves'; // 水波纹指令
import { getEmpInfo, getUserPermissions } from '../../../utils/auth';
import { checkEmpPwd } from '@/api/setting';

const emp = getEmpInfo()
export default {
  name: 'ComplexTable',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      const statusMap = {
        1: '正常',
        0: '禁用'
      }
      return statusMap[status]
    }
  },
  data () {
    return {
      emp: emp,
      tableKey: 0,
      list: [],
      total: null,
      listLoading: true,
      importanceOptions: [1, 2, 3],
      sortOptions: [
        { label: 'ID Ascending', key: '+id' },
        { label: 'ID Descending', key: '-id' }
      ],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      temp: {
        gradeId: undefined,
        gradeName: '',
        petrolSaleAmt: '',
        petrolPoint: '',
        dieselSaleAmt: '',
        dieselPoint: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogPvVisible: false,
      pvData: [],
      rules: {
        gradeName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        petrolSaleAmt: [
          {
            type: 'number',
            required: true,
            message: '请填写正确的金额',
            trigger: 'blur'
          }
        ],
        petrolPoint: [
          {
            type: 'number',
            required: true,
            message: '必须填写',
            trigger: 'blur'
          }
        ],
        dieselSaleAmt: [
          {
            type: 'number',
            required: true,
            message: '请填写正确的金额',
            trigger: 'blur'
          }
        ],
        dieselPoint: [
          {
            type: 'number',
            required: true,
            message: '必须填写',
            trigger: 'blur'
          }
        ]
      },
      downloadLoading: false
    }
  },
  created () {
    console.log('empInfo', emp)
    this.getList()
  },
  methods: {
    getList () {
      this.listLoading = true
      gradeList({ getAll: 1 }).then(response => {
        this.list = response.data.data
        // Just to simulate the time of the request
        this.listLoading = false
      })
    },
    handleModifyStatus (row, status) {
      const tempData = Object.assign({}, row)
      tempData.status = status
      updateGrade(tempData).then(res => {
        for (const v of this.list) {
          if (v.gradeId === row.gradeId) {
            console.log(tempData)
            const index = this.list.indexOf(v)
            this.list.splice(index, 1, tempData)
            break;
          }
        }
        this.$message({
          message: '操作成功',
          type: 'success'
        })
      })
    },
    resetTemp () {
      this.temp = {
        gradeId: undefined,
        gradeName: '',
        petrolSaleAmt: '',
        petrolPoint: '',
        dieselSaleAmt: '',
        dieselPoint: ''
      }
    },
    handleCreate () {
      if (!getUserPermissions('MEMBER_GRADE_EDIT')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return;
      }
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.resetTemp()
            this.dialogStatus = 'create';
            this.dialogFormVisible = true
            this.$nextTick(() => {
              this.$refs['dataForm'].clearValidate()
            })
          }
        })
      })
    },
    createData () {
      this.$refs['dataForm'].validate(valid => {
        if (this.temp.dieselSaleAmt < 0) {
          this.$message.error('错了哦，柴油优惠不能小于0')
          return;
        }
        if (this.temp.petrolSaleAmt < 0) {
          this.$message.error('错了哦，汽油优惠不能小于0')
          return;
        }
        if (valid) {
          console.log(valid)
          console.log(this.temp)
          createGrade(this.temp).then(res => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleUpdate (row) {
      if (!getUserPermissions('MEMBER_GRADE_EDIT')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return;
      }
      this.$prompt('请输入您的登录密码：', '提示', {
        inputType: 'password',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.{6}?/,
        inputErrorMessage: '密码格式不对',
        inputPlaceholder: '请输入密码',
        closeOnClickModal: false
      }).then(({ value }) => {
        checkEmpPwd({ pwd: value }).then(response => {
          if (response.data.code === 0) {
            this.temp = Object.assign({}, row) // copy obj
            this.temp.timestamp = new Date(this.temp.timestamp)
            this.dialogStatus = 'update';
            this.dialogFormVisible = true
            this.$nextTick(() => {
              this.$refs['dataForm'].clearValidate()
            })
          }
        })
      })
    },
    updateData () {
      this.$refs['dataForm'].validate(valid => {
        if (this.temp.dieselSaleAmt < 0) {
          this.$message.error('错了哦，柴油优惠不能小于0')
          return;
        }
        if (this.temp.petrolSaleAmt < 0) {
          this.$message.error('错了哦，汽油优惠不能小于0')
          return;
        }
        if (valid) {
          console.log(valid)
          const tempData = Object.assign({}, this.temp)
          tempData.timestamp = +new Date(tempData.timestamp) // change Thu Nov 30 2017 16:41:05 GMT+0800 (CST) to 1512031311464
          updateGrade(tempData).then(res => {
            for (const v of this.list) {
              if (v.gradeId === this.temp.gradeId) {
                const index = this.list.indexOf(v)
                this.list.splice(index, 1, this.temp)
                break;
              }
            }
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleDelete (row) {
      this.$notify({
        title: '成功',
        message: '删除成功',
        type: 'success',
        duration: 2000
      })
      const index = this.list.indexOf(row)
      this.list.splice(index, 1)
    }
  }
}
</script>
